const PRINCIPLES = [
  {
    icon: "ri-compass-3-line",
    title: "不传谣、不造谣",
    desc: "不基于单方爆料做主观定罪，不为了流量夸大或曲解事实，把未证实信息与已证实信息清楚分开。",
  },
  {
    icon: "ri-links-line",
    title: "可溯源、可回看",
    desc: "凡是重要结论都尽量给出可核对的角度，并保留更新时间线，方便读者回到原始出处自行验证。",
  },
  {
    icon: "ri-restart-line",
    title: "随事实更新",
    desc: "事件有新进展时，我们会及时修正此前内容，而不是把过时说法当作既定结论一直挂着。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        <div>
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
            <i className="ri-flag-line w-4 h-4 flex items-center justify-center" />
            07 · 关于本站
          </p>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            我们为什么要做这个梳理
          </h2>
          <p className="mt-5 text-foreground-700 text-sm md:text-base leading-loose">
            热点事件总会在几小时内被无数账号加工、放大，真正想搞清楚真相的人，往往被困在一堆互相矛盾的
            说法里。本站的初衷很简单：做一套<b className="font-semibold text-foreground-950">面向普通读者的信息梳理工具</b>，
            把如何起因、如何发酵、如何回应、如何沉淀的脉络讲明白，把散落的信息按节点和时间重新排好。
          </p>
          <p className="mt-3 text-foreground-700 text-sm md:text-base leading-loose">
            我们不替代权威信源，也不代替你思考，而是帮你建立起自己的判断框架——当下一波消息涌来时，
            你能知道该信什么、该存疑什么、该往哪里追。
          </p>

          <div className="mt-8 flex items-center gap-4 p-5 bg-background-100 border border-background-200 rounded-lg">
            <span className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-mail-send-line w-6 h-6 flex items-center justify-center" />
            </span>
            <div>
              <p className="font-label text-foreground-950">内容建议 / 纠错反馈</p>
              <a
                href="mailto:hello@kanliaomen-gate.com"
                className="text-sm text-primary-600 hover:text-primary-700 break-all"
              >
                hello@kanliaomen-gate.com
              </a>
              <p className="text-xs text-secondary-600 mt-0.5">
                若发现时间线或表述有误，欢迎来信指出，我们会尽快复核修正。
              </p>
            </div>
          </div>
        </div>

        <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
          <h3 className="font-heading font-semibold text-lg text-foreground-950">本站内容原则</h3>
          <div className="mt-5 flex flex-col gap-4">
            {PRINCIPLES.map((p) => (
              <div key={p.title} className="flex items-start gap-3">
                <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${p.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </span>
                <div>
                  <h4 className="font-heading font-semibold text-foreground-950">{p.title}</h4>
                  <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}